import { render, staticRenderFns } from "./DossierTextView.vue?vue&type=template&id=352d3567&"
import script from "./DossierTextView.vue?vue&type=script&lang=ts&"
export * from "./DossierTextView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports